import { Component, OnInit,Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eos-bulk-upload-confirmation',
  templateUrl: './bulk-upload-confirmation.component.html',
  styles: [`#bulkuploadBody{font-size:12px;}`]
})
export class BulkUploadConfirmationComponent implements OnInit {
  @Input() public invalidRecords=[];
  header = "Bulk upload confirmation";
  @Input() public selectedDocument: File;
  @Input() public fileName: string;
  @Input() public onUpload: (isUploaded: boolean) => void;
  constructor(private modalService: NgbModal,public modal: NgbActiveModal,) { }

  ngOnInit() {
  }

  upload() {
    this.onUpload(true);
  }
  closeAllModal() {
    this.modalService.dismissAll();
  }
}
